import { Box, LinearProgress, Paper, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "../../../theme/colors";

export const AuthContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  background: "white",
  flexDirection: "column",

  "& .loading-text":{
    color: '#000', 
    textAlign: 'center',
  }
}));

export const AuthCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(6),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: 16,
  width: "300px",
  maxWidth: 400,
  background: "white",
  position: "relative",
  overflow: "hidden",
}));

export const Logo = styled("img")({
  height: "43px",
  width: "auto",
});

export const ProgressContainer = styled(Box)(({ theme }) => ({
  width: "280px",
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(2),
}));

export const CustomLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 3,
  "& .MuiLinearProgress-bar": {
    backgroundColor: colors.primary,
  },
}));
